module.exports = __webpack_public_path__ + "static/media/malaysia.1a33f304.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/malaysia.png
// module id = 43
// module chunks = 0